import { Suspense, useRef, useState } from 'react';
import { Expand } from '@mui/icons-material';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { Box, Divider } from '@mui/material';
import { useMediaQuery } from '@mui/system';
import Sidebar from 'components/sidebar';
import AssetNavigation from '../asset-navigation';
import ParameterList from '../parameter-list-table';

function ParameterView() {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('md')); //900px
  const leftPanelRef = useRef(null);
  const [isPanelExpanded, setIsPanelExpanded] = useState(true);
  const [panelSize, setPanelSize] = useState(30);

  return (
    <Suspense fallback={null}>
      <Box
        aria-label="parametersPage"
        style={{
          display: 'flex',
          minHeight: '340px',
          maxHeight: 'calc(100vh - 64px)',
        }}
      >
        <Sidebar id="parameters-nav" />
        <PanelGroup
          direction="horizontal"
          style={{ height: 'inherit', flex: 1 }}
        >
          <Panel
            minSize={isSmallScreen ? 30 : 15}
            maxSize={isSmallScreen ? 60 : 40}
            defaultSize={30}
            collapsible={true}
            collapsedSize={isSmallScreen ? 8 : 2}
            ref={leftPanelRef}
            onResize={e => {
              setPanelSize(e);
              setIsPanelExpanded(!leftPanelRef.current.isCollapsed());
            }}
          >
            <AssetNavigation
              panelRef={leftPanelRef}
              isPanelExpanded={isPanelExpanded}
              setIsPanelExpanded={setIsPanelExpanded}
              panelSize={panelSize}
            />
          </Panel>
          <Divider orientation="vertical" flexItem />
          <PanelResizeHandle>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                backgroundColor: theme => theme.palette.action.hover,
              }}
            >
              <Expand
                color="action"
                fontSize="12px"
                sx={{
                  transform: 'rotate(90deg)',
                }}
              />
            </Box>
          </PanelResizeHandle>
          <Divider orientation="vertical" flexItem />
          <Panel>
            <ParameterList />
          </Panel>
        </PanelGroup>
      </Box>
    </Suspense>
  );
}

export default ParameterView;
